import { defineStore } from 'pinia'
import * as departmentApi from '../services/api/department'

export const Department = {
  NewCar: ['new_car', 'new_car_service'],
  UsedCar: ['sales', 'service'],
}

export const DepartmentRoleMapping: { [key: string]: string[] } = {
  other: ['director', 'accountant', 'bank_admin'],
  sales: [
    'purchasing_supervisor',
    'purchasing_admin',
    'purchasing_employee',
    'sales_admin',
    'sales_employee',
    'other_employee',
  ],
  service: [
    'service_manager',
    'service_adviser',
    'manager',
    'leader',
    'employee',
    'interior_employee',
    'garage_owner',
    'warehouseman',
  ],
  marketing: ['marketing_manager', 'customer_service', 'marketing_employee'],
  inspection: ['inspection_manager', 'assessor_employee'],
  new_car: [
    'new_car_supervisor',
    'new_car_admin',
    'new_car_insurance_admin',
    'new_car_sales_employee',
    'new_car_supporter',
  ],
  new_car_service: ['new_car_service_manager', 'new_car_service_adviser', 'new_car_service_admin'],
}

export const OtherDepartment = {
  id: null,
  name: 'Khác',
  type: 'other',
}

export interface IDepartmentData {
  id: number
  name: string
  type: string
}

export const useDepartmentStore = defineStore('Department', {
  state: () => ({
    isLoading: true,
    departments: [] as IDepartmentData[],
  }),
  actions: {
    setDepartments(data: IDepartmentData[]) {
      this.departments = data
    },
    setLoading(value: boolean) {
      this.isLoading = value
    },
    async listDepartments() {
      try {
        this.setLoading(true)
        const { data } = await departmentApi.list()
        this.setDepartments(data)
        this.setLoading(false)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
  },
})
